document.addEventListener('DOMContentLoaded', function() {
  initAllVideoSliders();
});

// Храним все инстансы слайдеров
var videoSliders = {};

function getReviewCard(el) {
  return el ? el.closest('[data-has-video="true"]') : null;
}
var currentlyPlayingVideo = null;

// Добавляем объект для отслеживания ручных пауз
var userPausedVideos = {};

// Храним активное видео для каждой секции
var activeVideoInSection = {};

function initAllVideoSliders() {
  document.querySelectorAll('[data-section-type="video-reviews"]').forEach(function(section) {
    initVideoSlider(section);
  });
  
  initIntersectionObserver();
  initVideoPosterSetting();
}

function initVideoPosterSetting() {
  const anchor = document.querySelector('.instagram-video-posters-anchor');
  if (!anchor) return;
  
  const videos = document.querySelectorAll('video[data-poster]');
  if (!videos.length) return;
  
  const applyPosters = () => {
    console.log('Applying');
    videos.forEach(video => {
      if (!video.getAttribute('poster')) {
        video.setAttribute('poster', video.dataset.poster);
      }
    });
  };
  
  // Fallback для старых браузеров
  if (!('IntersectionObserver' in window)) {
    console.log('instant');
    applyPosters();
    return;
  }
  
  const io = new IntersectionObserver((entries, obs) => {
    console.log('new IntersectionObserver');
    if (entries.some(e => e.isIntersecting)) {
      applyPosters();
      obs.disconnect();
    }
  }, {
    rootMargin: '200px 0px' // начинаем чуть заранее
  });
  
  io.observe(anchor);
}

function initVideoSlider(section) {
  var sectionId = section.dataset.sectionId;
  var $slider = jQuery(section).find('.js-reviews-slider');
  
  if (!$slider.length) return;
  
  // Уничтожаем старый слайдер
  if ($slider.hasClass('flickity-enabled')) {
    $slider.flickity('destroy');
  }
  
  // Определяем устройство
  var isMobile = window.innerWidth <= 767;
  
  // Настройки Flickity
  var options = {
    adaptiveHeight: false,
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    draggable: true,
    freeScroll: false,
    percentPosition: false,
    resize: true,
    on: {
      ready: function() {
        initVideoControls(sectionId);
        setupInitialAutoplay(sectionId);
      },
      change: function(index) {
        let flkty = this;
        let currentSlide = flkty.selectedElement;
        let sectionId = flkty.element.closest('[data-section-id]').dataset.sectionId;
        
        // Сохраняем активное видео для секции
        if (currentlyPlayingVideo) {
          var videoCard = getReviewCard(currentlyPlayingVideo);
          if (videoCard && videoCard.closest('[data-section-id]') === flkty.element.closest('[data-section-id]')) {
            activeVideoInSection[sectionId] = currentlyPlayingVideo;
          }
        }
        
        // Останавливаем текущее видео
        if (currentlyPlayingVideo) {
          currentlyPlayingVideo.pause();
          updatePlayIcon(getReviewCard(currentlyPlayingVideo), false);
          currentlyPlayingVideo = null;
        }
        
        // Для мобильных - автовоспроизведение текущего слайда
        if (isMobile) {
          var videoElement = currentSlide.querySelector('[data-video-element]');
          if (videoElement && !isUserPaused(videoElement)) {
            videoElement.play().catch(function(e) {
              console.log('Mobile autoplay failed:', e);
            });
            updatePlayIcon(currentSlide, true);
            currentlyPlayingVideo = videoElement;
            activeVideoInSection[sectionId] = videoElement;
          } else if (videoElement) {
            // Если видео было на паузе пользователем - обновляем иконку
            updatePlayIcon(currentSlide, false);
          }
        }
      },
      settle: function() {
        if (!isMobile) {
          var flkty = this;
          var section = flkty.element.closest('[data-section-type="video-reviews"]');
          checkSectionVisibility(section);
        }
      }
    }
  };
  
  // Инициализируем слайдер
  $slider.flickity(options);
  var flkty = $slider.data('flickity');
  initVideoControls(sectionId);
  
  // Сохраняем инстанс
  videoSliders[sectionId] = {
    instance: flkty,
    element: $slider[0],
    isMobile: isMobile,
    lastActiveVideo: null
  };
  
  // Кнопки навигации
  jQuery(section).find('.reviews-prev').on('click', function() {
    $slider.flickity('previous');
  });
  
  jQuery(section).find('.reviews-next').on('click', function() {
    $slider.flickity('next');
  });
  
  // Обработчики для ресайза
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      var newIsMobile = window.innerWidth <= 767;
      if (videoSliders[sectionId]) {
        videoSliders[sectionId].isMobile = newIsMobile;
      }
      
      if (flkty) {
        flkty.reloadCells();
        flkty.resize();
        
        // Переустанавливаем автовоспроизведение после ресайза
        setupInitialAutoplay(sectionId);
      }
    }, 250);
  });
}

// Начальная настройка автовоспроизведения
function setupInitialAutoplay(sectionId) {
  var section = document.querySelector('#shopify-section-' + sectionId);
  if (!section) return;
  
  var sliderData = videoSliders[sectionId];
  var isMobile = sliderData ? sliderData.isMobile : window.innerWidth <= 767;
  
  // Останавливаем все видео в секции
  section.querySelectorAll('[data-video-element]').forEach(function(video) {
    if (!video.paused) {
      video.pause();
      updatePlayIcon(getReviewCard(video), false);
    }
  });
  
  // Сбрасываем глобальное состояние
  currentlyPlayingVideo = null;
  
  // Проверяем, есть ли сохраненное активное видео для этой секции
  var savedActiveVideo = activeVideoInSection[sectionId];
  
  if (savedActiveVideo && savedActiveVideo.parentNode && section.contains(savedActiveVideo)) {
    // Восстанавливаем сохраненное видео
    if (!isUserPaused(savedActiveVideo)) {
      if (isMobile) {
        savedActiveVideo.play().catch(function(e) {
          console.log('Restored mobile autoplay failed:', e);
        });
        updatePlayIcon(getReviewCard(savedActiveVideo), true);
        currentlyPlayingVideo = savedActiveVideo;
      } else {
        // Для десктопов воспроизводим только если секция видима
        var sectionRect = section.getBoundingClientRect();
        var windowHeight = window.innerHeight;
        var sectionMiddle = sectionRect.top + sectionRect.height / 2;
        var isSectionVisible = sectionMiddle >= 0 && sectionMiddle <= windowHeight;
        
        if (isSectionVisible) {
          savedActiveVideo.play().catch(function(e) {
            console.log('Restored desktop autoplay failed:', e);
          });
          updatePlayIcon(getReviewCard(savedActiveVideo), true);
          currentlyPlayingVideo = savedActiveVideo;
        } else {
          // Секция не видна - обновляем иконку на паузу
          updatePlayIcon(getReviewCard(savedActiveVideo), false);
        }
      }
    } else {
      // Видео было на паузе пользователем - обновляем иконку
      updatePlayIcon(getReviewCard(savedActiveVideo), false);
    }
  } else {
    // Нет сохраненного видео - воспроизводим первое
    if (isMobile) {
      // На мобильных: автовоспроизведение первого видео
      var firstVideo = section.querySelector('[data-video-element]');
      if (firstVideo && !isUserPaused(firstVideo)) {
        firstVideo.play().catch(function(e) {
          console.log('Initial mobile autoplay failed:', e);
        });
        updatePlayIcon(getReviewCard(firstVideo), true);
        currentlyPlayingVideo = firstVideo;
        activeVideoInSection[sectionId] = firstVideo;
      } else if (firstVideo) {
        // Если первое видео на паузе - обновляем иконку
        updatePlayIcon(getReviewCard(firstVideo), false);
      }
    } else {
      // На ПК: автовоспроизведение только первого видео
      var firstVideo = section.querySelector('[data-video-element]');
      if (firstVideo && !isUserPaused(firstVideo)) {
        // Проверяем, видна ли секция
        var sectionRect = section.getBoundingClientRect();
        var windowHeight = window.innerHeight;
        var sectionMiddle = sectionRect.top + sectionRect.height / 2;
        var isSectionVisible = sectionMiddle >= 0 && sectionMiddle <= windowHeight;
        
        if (isSectionVisible) {
          firstVideo.play().catch(function(e) {
            console.log('Initial desktop autoplay failed:', e);
          });
          updatePlayIcon(getReviewCard(firstVideo), true);
          currentlyPlayingVideo = firstVideo;
          activeVideoInSection[sectionId] = firstVideo;
        } else {
          // Секция не видна - обновляем иконку на паузу
          updatePlayIcon(getReviewCard(firstVideo), false);
        }
      } else if (firstVideo) {
        // Если первое видео на паузе - обновляем иконку
        updatePlayIcon(getReviewCard(firstVideo), false);
      }
    }
  }
}

// Инициализация контролов видео
function initVideoControls(sectionId) {
  var section = document.querySelector('#shopify-section-' + sectionId);
  if (!section || section.dataset.videoControlsInit === 'true') return;
  section.dataset.videoControlsInit = 'true';

  // Не даём Flickity перехватывать клики по кнопкам
  section.addEventListener('pointerdown', function(e) {
    if (e.target.closest('.video-btn')) {
      e.stopPropagation();
    }
  }, true);
  
  // Клик на видео-контейнер
  section.querySelectorAll('[data-video-container]').forEach(function(container) {
    container.addEventListener('click', function(e) {
      if (e.target.closest('.video-btn')) return;
      
      var video = this.querySelector('[data-video-element]');
      var videoSectionId = this.closest('[data-section-id]').dataset.sectionId;
      
      // Если кликаем на уже играющее видео - ставим на паузу
      if (video === currentlyPlayingVideo) {
        video.pause();
        updatePlayIcon(getReviewCard(this), false);
        currentlyPlayingVideo = null;
        markAsUserPaused(video, true); // Отмечаем как ручную паузу
        delete activeVideoInSection[videoSectionId]; // Удаляем из активных
        return;
      }
      
      // Останавливаем текущее видео если оно есть
      if (currentlyPlayingVideo && currentlyPlayingVideo !== video) {
        currentlyPlayingVideo.pause();
        updatePlayIcon(getReviewCard(currentlyPlayingVideo), false);
      }
      
      // Снимаем пометку о ручной паузе при клике на другое видео
      markAsUserPaused(video, false);
      
      // Сохраняем как активное видео для секции
      activeVideoInSection[videoSectionId] = video;
      
      // Запускаем новое видео
      if (video.paused) {
        video.play();
        updatePlayIcon( this.closest('[data-has-video="true"]'), true);
        currentlyPlayingVideo = video;
      }
    });
  });
  
  // Кнопка Play/Pause
  section.querySelectorAll('[data-play-btn]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var card =  this.closest('[data-has-video="true"]');
      var video = card.querySelector('[data-video-element]');
      var videoSectionId = card.closest('[data-section-id]').dataset.sectionId;
      
      if (video === currentlyPlayingVideo) {
        video.pause();
        updatePlayIcon(card, false);
        currentlyPlayingVideo = null;
        markAsUserPaused(video, true); // Отмечаем как ручную паузу
        delete activeVideoInSection[videoSectionId]; // Удаляем из активных
        return;
      }
      
      if (currentlyPlayingVideo && currentlyPlayingVideo !== video) {
        currentlyPlayingVideo.pause();
        updatePlayIcon(getReviewCard(currentlyPlayingVideo), false);
      }
      
      // Снимаем пометку о ручной паузе при клике на play
      if (video.paused) {
        markAsUserPaused(video, false);
        video.play();
        updatePlayIcon(card, true);
        currentlyPlayingVideo = video;
        activeVideoInSection[videoSectionId] = video;
      } else {
        video.pause();
        updatePlayIcon(card, false);
        currentlyPlayingVideo = null;
        markAsUserPaused(video, true); // Отмечаем как ручную паузу
        delete activeVideoInSection[videoSectionId]; // Удаляем из активных
      }
    });
  });
  
  // Кнопка Mute/Unmute
  section.querySelectorAll('[data-mute-btn]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var card = this.closest('[data-has-video="true"]');
      if (!card) return;
      var video = card.querySelector('[data-video-element]');
      if (!video) return;

      video.muted = !video.muted;

      var volumeOnIcon = btn.querySelector('[data-volume-on-icon]');
      var volumeOffIcon = btn.querySelector('[data-volume-off-icon]');
      if (!volumeOnIcon || !volumeOffIcon) return;

      if (video.muted) {
        volumeOnIcon.style.display = 'none';
        volumeOffIcon.style.display = 'block';
      } else {
        volumeOnIcon.style.display = 'block';
        volumeOffIcon.style.display = 'none';
      }
    });
  });
  
  // События видео
  section.querySelectorAll('[data-video-element]').forEach(function(video) {
    // Добавляем уникальный идентификатор для видео
    if (!video.dataset.videoId) {
      video.dataset.videoId = 'video_' + Math.random().toString(36).substr(2, 9);
    }
    
    video.addEventListener('play', function() {
      var card = this.closest('[data-has-video="true"]');
      var sectionId = card.closest('[data-section-id]').dataset.sectionId;
      updatePlayIcon(card, true);
      // При воспроизведении снимаем пометку о ручной паузе
      markAsUserPaused(this, false);
      // Сохраняем как активное видео для секции
      activeVideoInSection[sectionId] = this;
    });
    
    video.addEventListener('pause', function() {
      var card = this.closest('[data-has-video="true"]');
      updatePlayIcon(card, false);
      
      // Если пауза вызвана не переходом слайда (т.е. currentlyPlayingVideo не сменился)
      // то это, скорее всего, ручная пауза пользователя
      if (currentlyPlayingVideo === this) {
        // Даем небольшую задержку, чтобы убедиться, что это не пауза от переключения слайдов
        setTimeout(() => {
          if (currentlyPlayingVideo === this) {
            markAsUserPaused(this, true);
            var sectionId = card.closest('[data-section-id]').dataset.sectionId;
            delete activeVideoInSection[sectionId]; // Удаляем из активных
          }
        }, 100);
      }
    });
    
    video.addEventListener('ended', function() {
      if (this === currentlyPlayingVideo) {
        currentlyPlayingVideo = null;
      }
      // При завершении видео - сбрасываем на начало
      this.currentTime = 0;
      // Снимаем пометку о ручной паузе при завершении
      markAsUserPaused(this, false);
      var card = getReviewCard(this);
      var sectionId = card && card.closest('[data-section-id]').dataset.sectionId;
      delete activeVideoInSection[sectionId]; // Удаляем из активных при завершении
      updatePlayIcon(card, false); // Обновляем иконку при завершении
    });
  });
}

// Функция для пометки видео как приостановленного пользователем
function markAsUserPaused(video, isPaused) {
  if (!video || !video.dataset.videoId) return;
  
  if (isPaused) {
    userPausedVideos[video.dataset.videoId] = true;
  } else {
    delete userPausedVideos[video.dataset.videoId];
  }
}

// Функция для проверки, было ли видео приостановлено пользователем
function isUserPaused(video) {
  if (!video || !video.dataset.videoId) return false;
  return !!userPausedVideos[video.dataset.videoId];
}

// Обновление иконки Play/Pause
function updatePlayIcon(cardOrVideo, isPlaying) {
  var card = cardOrVideo && cardOrVideo.matches && cardOrVideo.matches('[data-has-video="true"]')
    ? cardOrVideo
    : getReviewCard(cardOrVideo);
  if (!card) return;
  
  var playIcon = card.querySelector('[data-play-icon]');
  var pauseIcon = card.querySelector('[data-pause-icon]');
  
  if (isPlaying) {
    if (playIcon) playIcon.style.display = 'none';
    if (pauseIcon) pauseIcon.style.display = 'block';
  } else {
    if (playIcon) playIcon.style.display = 'block';
    if (pauseIcon) pauseIcon.style.display = 'none';
  }
}

// Intersection Observer для десктопа и мобильных
function initIntersectionObserver() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var section = entry.target;
      var sectionId = section.dataset.sectionId;
      var sliderData = videoSliders[sectionId];
      
      if (!sliderData) return;
      
      var isMobile = sliderData.isMobile;
      
      if (entry.isIntersecting) {
        // Секция стала видимой
        
        if (isMobile) {
          // На мобильных: воспроизводим текущий слайд
          var flkty = sliderData.instance;
          if (flkty) {
            var currentSlide = flkty.selectedElement;
            if (currentSlide) {
              var video = currentSlide.querySelector('[data-video-element]');
              // Проверяем, не воспроизводим ли мы уже сохраненное видео
              var savedVideo = activeVideoInSection[sectionId];
              if (savedVideo && savedVideo !== video) {
                // Останавливаем сохраненное видео если оно не в текущем слайде
                if (!savedVideo.paused) {
                  savedVideo.pause();
                  updatePlayIcon(savedVideo, false);
                }
                delete activeVideoInSection[sectionId];
              }
              
              if (video && video.paused && !isUserPaused(video)) {
                // Останавливаем текущее глобальное видео если оно есть
                if (currentlyPlayingVideo && currentlyPlayingVideo !== video) {
                  currentlyPlayingVideo.pause();
                  updatePlayIcon(currentlyPlayingVideo, false);
                }
                
                video.play().catch(function(e) {
                  console.log('Mobile autoplay on scroll failed:', e);
                });
                updatePlayIcon(currentSlide, true);
                currentlyPlayingVideo = video;
                activeVideoInSection[sectionId] = video;
              } else if (video) {
                // Если видео на паузе (или пользовательской паузе) - обновляем иконку
                updatePlayIcon(currentSlide, false);
              }
            }
          }
        } else {
          // На десктопе: воспроизводим активное видео для секции
          var savedVideo = activeVideoInSection[sectionId];
          
          if (savedVideo && savedVideo.parentNode && section.contains(savedVideo)) {
            // Воспроизводим сохраненное активное видео
            if (savedVideo.paused && !isUserPaused(savedVideo)) {
              // Останавливаем текущее глобальное видео если оно есть
              if (currentlyPlayingVideo && currentlyPlayingVideo !== savedVideo) {
                currentlyPlayingVideo.pause();
                updatePlayIcon(currentlyPlayingVideo, false);
              }
              
              savedVideo.play().catch(function(e) {
                console.log('Desktop autoplay on scroll failed:', e);
              });
              updatePlayIcon(savedVideo, true);
              currentlyPlayingVideo = savedVideo;
            } else if (savedVideo) {
              // Если видео на паузе - обновляем иконку
              updatePlayIcon(savedVideo, false);
            }
          } else {
            // Нет сохраненного видео - воспроизводим первый слайд
            var flkty = sliderData.instance;
            if (flkty && flkty.selectedIndex === 0) {
              var firstSlide = flkty.selectedElement;
              if (firstSlide) {
                var video = firstSlide.querySelector('[data-video-element]');
                if (video && video.paused && !isUserPaused(video)) {
                  // Останавливаем текущее глобальное видео если оно есть
                  if (currentlyPlayingVideo && currentlyPlayingVideo !== video) {
                    currentlyPlayingVideo.pause();
                    updatePlayIcon(currentlyPlayingVideo, false);
                  }
                  
                  video.play().catch(function(e) {
                    console.log('Desktop autoplay on scroll failed:', e);
                  });
                  updatePlayIcon(firstSlide, true);
                  currentlyPlayingVideo = video;
                  activeVideoInSection[sectionId] = video;
                } else if (video) {
                  // Если видео на паузе - обновляем иконку
                  updatePlayIcon(firstSlide, false);
                }
              }
            }
          }
        }
      } else {
        // Секция скрыта - останавливаем все видео в ней и обновляем иконки
        stopAllVideosInSection(sectionId);
      }
    });
  }, {
    threshold: 0.3,
    rootMargin: '0px 0px -100px 0px'
  });
  
  // Наблюдаем за всеми секциями
  document.querySelectorAll('[data-section-type="video-reviews"]').forEach(function(section) {
    observer.observe(section);
  });
}

// Остановка всех видео в секции
function stopAllVideosInSection(sectionId) {
  var section = document.querySelector('#shopify-section-' + sectionId);
  if (!section) return;
  
  section.querySelectorAll('[data-video-element]').forEach(function(video) {
    if (!video.paused) {
      video.pause();
      updatePlayIcon(video, false);
      
      if (video === currentlyPlayingVideo) {
        currentlyPlayingVideo = null;
      }
    }
  });
}

// Проверка видимости секции (для совместимости)
function checkSectionVisibility(section) {
  var rect = section.getBoundingClientRect();
  var windowHeight = window.innerHeight;
  var sectionMiddle = rect.top + rect.height / 2;
  var isVisible = sectionMiddle >= 0 && sectionMiddle <= windowHeight;
  
  var sectionId = section.dataset.sectionId;
  var sliderData = videoSliders[sectionId];
  
  if (isVisible && sliderData && !sliderData.isMobile) {
    // Проверяем есть ли сохраненное активное видео
    var savedVideo = activeVideoInSection[sectionId];
    
    if (savedVideo && savedVideo.parentNode && section.contains(savedVideo)) {
      if (savedVideo.paused && !isUserPaused(savedVideo)) {
        savedVideo.play().catch(function(e) {
          console.log('Desktop autoplay failed:', e);
        });
        updatePlayIcon(savedVideo, true);
        currentlyPlayingVideo = savedVideo;
      } else if (savedVideo) {
        // Если видео на паузе - обновляем иконку
        updatePlayIcon(savedVideo, false);
      }
    } else {
      // Нет сохраненного - проверяем первый слайд
      var flkty = sliderData.instance;
      if (flkty && flkty.selectedIndex === 0) {
        var firstSlide = flkty.selectedElement;
        if (firstSlide) {
          var video = firstSlide.querySelector('[data-video-element]');
          if (video && video.paused && !currentlyPlayingVideo && !isUserPaused(video)) {
            video.play().catch(function(e) {
              console.log('Desktop autoplay failed:', e);
            });
            updatePlayIcon(firstSlide, true);
            currentlyPlayingVideo = video;
            activeVideoInSection[sectionId] = video;
          } else if (video) {
            // Если видео на паузе - обновляем иконку
            updatePlayIcon(firstSlide, false);
          }
        }
      }
    }
  }
}